import gsap from "gsap";

export default class ShowcaseButtons {
    constructor() {
        this.init();
        this.parallax(".showcase-image-box.one-varsity", -44, 0);
        this.parallax(".showcase-image-box.townside-village", -44, 0);
        this.parallax(".showcase-image-box.highstreet-village", -44, 0);
        this.parallax(".showcase-image-box.executive", -33, 11);
        this.parallax(".showcase-image-box.the-grand", -44, 0);
        this.parallax(".showcase-image-box.laurel-on-mill-lake", -44, 0);
        this.parallax(".showcase-image-box.one-zen", -22, 22);
        this.parallax(".showcase-image-box.queenston", -22, 22);

        this.parallax(".showcase-image-box.sidebar-grill", -22, 22);
        this.parallax(".showcase-image-box.upstream-health", -22, 22);
        this.parallax(".showcase-image-box.one-water-street", -22, 22);
        this.parallax(".showcase-image-box.latimer-heights", -22, 22);
        this.parallax(".showcase-image-box.fifty-ave", -22, 22);
        this.parallax(".showcase-image-box.run-for-water", -22, 22);
    }

    init() {
        const buttons = document.querySelectorAll(".showcase-button");

        buttons.forEach((item) => {
            item.addEventListener(
                "click",
                (event) => {
                    event.preventDefault();
                    const link = event.target.getAttribute("data-url");
                    window.open(link, "_self");
                },
                false
            );

            item.addEventListener("touchend", (event) => {
                event.preventDefault();
                const link = event.target.getAttribute("data-url");
                window.open(link, "_self");
            });
        });
    }

    parallax(ele, start, end) {
        gsap.fromTo(
            `${ele} > img`,
            {
                yPercent: start,
            },
            {
                yPercent: end,
                scrollTrigger: {
                    trigger: ele,
                    start: "top 100%",
                    end: "bottom 0%",
                    scrub: true,
                    markers: false,
                },
            }
        );
    }
}
